import React, { useEffect, useState } from "react";
import { Table, Button, message, Popconfirm } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import api from "../api";
import ProductoModal from "../components/ProductoModal";

const ProductosPage = () => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editingProducto, setEditingProducto] = useState(null);

  const getProductos = async () => {
    try {
      setLoading(true);
      const res = await api.get("/productos");
      setProductos(res.data.data || []);
    } catch (err) {
      message.error("Error al obtener productos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProductos();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/productos/${id}`);
      message.success("Producto eliminado exitosamente");
      getProductos();
    } catch (err) {
      message.error("Error al eliminar producto");
    }
  };

  const showEditModal = (producto) => {
    setEditingProducto(producto);
    setOpen(true);
  };

  const closeAndRefresh = () => {
    setOpen(false);
    setEditingProducto(null);
    getProductos();
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: 600, margin: 0 }}>Lista de Productos</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setEditingProducto(null);
            setOpen(true);
          }}
        >
          Nuevo Producto
        </Button>
      </div>
      <Table
        dataSource={productos}
        loading={loading}
        rowKey="idproductos"
        columns={[
          { title: "Nombre", dataIndex: "nombre" },
          {
            title: "Acciones",
            render: (_, record) => (
              <div style={{ display: "flex", gap: "8px" }}>
                <Button
                  type="text"
                  icon={<EditOutlined style={{ color: "blue" }} />}
                  onClick={() => showEditModal(record)}
                />
                <Popconfirm
                  title="¿Estás seguro de eliminar este producto?"
                  onConfirm={() => handleDelete(record.idproductos)}
                  okText="Sí"
                  cancelText="No"
                >
                  <Button type="text" icon={<DeleteOutlined style={{ color: "red" }} />} />
                </Popconfirm>
              </div>
            ),
          },
        ]}
        scroll={{ x: 'max-content' }}
      />

      <ProductoModal
        open={open}
        producto={editingProducto}
        onCancel={() => {
          setOpen(false);
          setEditingProducto(null);
        }}
        onSuccess={closeAndRefresh}
      />
    </>
  );
};

export default ProductosPage;
